import React, { Component } from 'react'

import './connectorline.scss'

class ConnectorLine extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    let lineClass = 'connectorLine'
    if (this.props.className) {
      lineClass += ` ${this.props.className}`
    }
    return <div className={lineClass} />
  }
}

export default ConnectorLine



// WEBPACK FOOTER //
// ./src/app/shared/elements/connectorLine/index.js